import { EVENT_BADGE } from '@/constants/badge'

interface IEvent {
  name: string
}

export const hasDoubleEleven = (eventList: IEvent[]) => {
  let result = false

  eventList.forEach((event: IEvent) => {
    if (EVENT_BADGE.DOUBLE_ELEVEN.includes(event?.name)) {
      result = true
    }
  })

  return result
}
